module.exports = __webpack_public_path__ + "static/media/amp-logo.23679837.png";